export const DELIVERY_STEPS = [
  { stage: 'PROGRAMADA', label: 'Programada' },
  { stage: 'VISITADA', label: 'Visitada' },
  { stage: 'EN_REVISION', label: 'En revisión' },
  { stage: 'LISTA_PARA_ENTREGA', label: 'Lista para entrega' },
  { stage: 'LIBERADA', label: 'Liberada' },
  { stage: 'ENTREGADA', label: 'Entregada' }
];

const STAGE_CHIPS = {
  PENDIENTE: { label: 'Sin programar', color: 'default' },
  PROGRAMADA: { label: 'Programada', color: 'default' },
  VISITADA: { label: 'Visitada', color: 'info' },
  EN_REVISION: { label: 'En revisión de calidad', color: 'warning' },
  LISTA_PARA_ENTREGA: { label: 'Lista para entrega', color: 'primary' },
  LIBERADA: { label: 'Liberada · esperando acuse', color: 'secondary' },
  ENTREGADA: { label: 'Entregada', color: 'success' },
  CANCELADA: { label: 'Cancelada', color: 'default' }
};

export const stageChip = (stage) => STAGE_CHIPS[stage] || { label: stage || '—', color: 'default' };

export const activeStepIndex = (stage) => {
  if (stage === 'ENTREGADA') return DELIVERY_STEPS.length;
  const i = DELIVERY_STEPS.findIndex((s) => s.stage === stage);
  return i < 0 ? 0 : i;
};

const QA_LABELS = {
  PENDIENTE_REVISION: { label: 'Pendiente 1ª ronda', color: 'default' },
  REVISION_1_APROBADA: { label: 'Aprobado 1ª ronda', color: 'info' },
  REVISION_1_RECHAZADA: { label: 'Rechazado 1ª ronda', color: 'error' },
  REVISION_2_APROBADA: { label: 'Aprobado 2ª ronda', color: 'success' },
  REVISION_2_RECHAZADA: { label: 'Rechazado 2ª ronda', color: 'error' }
};

export const qaChip = (doc) => {
  if (!doc.available) return { label: 'No generado', color: 'default' };
  if (!doc.required) return { label: 'Generado', color: 'success' };
  return QA_LABELS[doc.qaStatus] || { label: doc.qaStatus || '—', color: 'default' };
};

export const DELIVERY_ROLES = ['ADMINISTRADOR', 'ADMIN', 'COORDINADOR_OPERACIONES', 'SUPERVISOR_CALIDAD'];

export const canManageDeliveries = (role) => DELIVERY_ROLES.includes(String(role || '').toUpperCase());

export const isValidEmail = (value) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(value || '').trim());
